import { Icon } from '@chakra-ui/react';

export const CircleBadgeIcon = (props: any) => (
  <Icon viewBox="0 0 36 36" width="40px" height="auto" {...props}>
    <path
      fill="currentColor"
      d="M18,0C8.1,0,0,8.1,0,18c0,9.9,8.1,18,18,18c9.9,0,18-8.1,18-18C36,8.1,27.9,0,18,0z M29.2,21.8l-3.7,1.4
      l-0.2,4c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.1-0.5,0.1l-3.9-1l-2.5,3.1C18.1,29.9,18,30,17.8,30c-0.2,0-0.3-0.1-0.4-0.2l-2.5-3.1
      l-3.8,1c0,0-0.1,0-0.1,0c-0.3,0-0.6-0.2-0.6-0.5l-0.2-4l-3.7-1.4c0,0-0.1,0-0.1-0.1C6,21.6,5.9,21.2,6.1,21l2.2-3.3l-2.2-3.3
      c0,0,0-0.1-0.1-0.1c-0.1-0.3,0-0.6,0.3-0.7l3.7-1.4l0.2-4c0,0,0-0.1,0-0.1c0.1-0.3,0.4-0.5,0.7-0.4l3.8,1l2.5-3.1
      c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0.1,0.4,0.2l2.5,3.1l3.9-1c0.2,0,0.3,0,0.5,0.1c0.1,0.1,0.2,0.3,0.2,0.4l0.2,4l3.7,1.4
      c0,0,0.1,0,0.1,0.1c0.3,0.2,0.3,0.5,0.2,0.8l-2.2,3.3l2.2,3.4c0,0,0,0.1,0.1,0.1l0,0C29.7,21.4,29.5,21.7,29.2,21.8z"
    />
    <g>
      <path
        fill="currentColor"
        d="M20,19.8c0-0.2-0.1-0.3-0.3-0.3h-1v-6.7c0,0,0,0,0-0.1c0-0.2-0.1-0.3-0.3-0.2l-3.1,0.2c0,0,0,0-0.1,0
        c-0.1,0-0.2,0.1-0.2,0.3v1.4c0,0.2,0.1,0.3,0.3,0.3h1v4.8h-1.1c0,0,0,0,0,0c-0.2,0-0.3,0.2-0.3,0.3v1.5c0,0,0,0,0,0.1
        c0,0.2,0.1,0.3,0.3,0.2h4.4c0,0,0,0,0.1,0l0,0c0.2,0,0.3-0.1,0.2-0.3L20,19.8C20,19.8,20,19.8,20,19.8z"
      />
      <path
        fill="currentColor"
        d="M17.5,9.7c-4.2,0-7.6,3.4-7.6,7.6c0,4.2,3.4,7.6,7.6,7.6s7.6-3.4,7.6-7.6C25.2,13.1,21.7,9.7,17.5,9.7z
        M17.5,24.2c-3.8,0-6.8-3-6.8-6.8s3-6.8,6.8-6.8c3.8,0,6.8,3,6.8,6.8C24.3,21.1,21.3,24.2,17.5,24.2z"
      />
    </g>
  </Icon>
);

export const LogoIconLarge = (props: any) => (
  <Icon height="24px" width="auto" viewBox="0 0 136 24" {...props}>
    <path
      fillRule="evenodd"
      d="M66.397 6.887c-2.775 0-5.067.25-5.067 2.124v9.317h2.62V9.873c0-.48 1.355-.577 2.097-.577 2.383 0 2.336 1.045 2.336 2.037v6.995h2.602v-7.053c0-3.134-1.552-4.388-4.588-4.388zm66.757 11.449h2.68V2.786h-2.68v15.55zm-5.808 0h2.682V2.786h-2.682v15.55zm-7.589-2.018c-1.594 0-2.603-.59-2.603-3.579 0-2.99 1.009-3.58 2.603-3.58 1.59 0 2.601.59 2.601 3.58s-1.01 3.579-2.6 3.579zm0-9.401c-3.41 0-5.292 2.06-5.292 5.822s1.882 5.822 5.292 5.822c3.406 0 5.29-2.06 5.29-5.822 0-3.761-1.884-5.822-5.29-5.822zM107.52 8.34v9.995h2.684V9.903c0-.66 1.646-.64 3.141-.663V6.894s-5.825-.243-5.825 1.447zm-7.143 6.587-2.503-7.854h-2.834l3.994 10.674c-.14.398 0 .003-2.034 5.036l2.802.002 1.623-4.18 4.244-11.532h-2.836l-2.456 7.854zm-11.79-8.034c-.871 0-1.61.135-2.234.383V2.786h-2.679v15.55h2.679V9.624c.446-.203 1.05-.339 1.785-.339 2.502 0 2.726 1.06 2.726 2.055v6.996h2.658v-6.771c0-2.934-1.832-4.671-4.934-4.671zm-7.323 8.778c-.83.34-1.75.566-2.784.566-1.883 0-3.052-.59-3.052-3.493 0-2.925 1.169-3.492 3.052-3.492 1.034 0 1.953.204 2.784.543V7.528a8.639 8.639 0 0 0-3.233-.634c-3.41 0-5.299 2.087-5.299 5.85 0 3.767 1.89 5.831 5.299 5.831 1.192 0 2.27-.252 3.233-.636v-2.267zm-25.05-2.049c0 1.812-.656 2.431-2.289 2.431-1.613 0-2.268-.619-2.268-2.43v-6.55h-2.638v6.185c0 3.33 1.07 5.302 4.906 5.302 3.826 0 4.928-1.971 4.928-5.302V7.074h-2.64v6.55zM43.831 9.91c0-.667 1.632-.646 3.127-.67V6.894s-5.807-.237-5.807 1.447v9.995h2.68V9.91zM11.892 0c6.569 0 11.893 5.325 11.893 11.892 0 .236-.007.469-.02.7-.376-5.43-4.9-9.72-10.427-9.72-5.773 0-10.454 4.68-10.454 10.453 0 5.56 4.34 10.103 9.817 10.433-.267.018-.536.027-.809.027C5.325 23.785 0 18.461 0 11.892 0 5.325 5.325 0 11.892 0zm2.055 5.572a8.32 8.32 0 0 1 3.886.957 3.806 3.806 0 0 0 1.292 7.385 3.8 3.8 0 0 0 3.039-1.516 8.357 8.357 0 0 1-8.217 9.889 8.357 8.357 0 0 1-8.357-8.358 8.357 8.357 0 0 1 8.357-8.357zm21.346 1.322c1.188 0 2.265.249 3.23.634v2.265a7.265 7.265 0 0 0-2.78-.542c-1.885 0-3.05.566-3.05 3.488 0 2.9 1.165 3.49 3.05 3.49 1.029 0 1.949-.226 2.78-.565v2.265a8.661 8.661 0 0 1-3.23.634c-3.41 0-5.293-2.06-5.293-5.824 0-3.761 1.882-5.845 5.293-5.845z"
    ></path>
  </Icon>
);

export const LogoIconSmall = (props: any) => (
  <Icon height="24px" width="auto" viewBox="0 0 24 24" {...props}>
    <path d="M19.125 13.914a3.804 3.804 0 0 1-1.292-7.385 8.357 8.357 0 0 0-12.243 7.4 8.357 8.357 0 0 0 8.357 8.357 8.357 8.357 0 0 0 8.217-9.888 3.8 3.8 0 0 1-3.04 1.516M11.893 0C5.325 0 0 5.325 0 11.892c0 6.569 5.325 11.893 11.892 11.893.273 0 .542-.01.809-.027-5.476-.33-9.817-4.873-9.817-10.433 0-5.773 4.68-10.453 10.454-10.453 5.527 0 10.051 4.29 10.427 9.72.013-.231.02-.464.02-.7C23.785 5.325 18.461 0 11.892 0"></path>
  </Icon>
);

export const HamburgerIcon = (props: any) => (
  <Icon height="24px" width="24px" viewBox="0 0 24 24" {...props}>
    <path d="M21 4a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2h18zm0 7a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2h18zm0 7a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2h18z"></path>
  </Icon>
);

export const ExitIcon = (props: any) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5 1.5H17.5L7.5 1.5V3.5L16.5 3.5V16.5H7.5V18.5L17.5 18.5H18.5L18.5 17.5V2.5V1.5ZM9.58579 11L3 11V9H9.58579L7.29289 6.70711L8.70711 5.29289L12.7071 9.29289L13.4142 10L12.7071 10.7071L8.70711 14.7071L7.29289 13.2929L9.58579 11Z"
      fill="currentColor"
    />
  </Icon>
);

export const ImagePlaceholderIcon = (props: any) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.973 2.77344V12.8534H2.02637V2.77344H13.973ZM12.853 3.89344H3.14637V10.6166L3.26153 10.5072L3.48779 10.2869L3.69677 10.0775L3.83075 9.93964L4.03011 9.729L4.23521 9.50588C5.15147 8.49644 5.84595 7.49829 6.28495 6.4789L6.34397 6.33578L6.35979 6.2767C6.39039 6.16952 6.43694 6.04819 6.5048 5.92192L6.54812 5.84565C6.78025 5.45817 7.14178 5.2001 7.62637 5.2001C7.70087 5.2001 7.77463 5.21497 7.84332 5.24384C7.98616 5.30386 8.14235 5.39025 8.31444 5.49986C8.38532 5.545 8.45825 5.59373 8.53285 5.64554C8.62294 5.7081 8.7128 5.77326 8.8008 5.83926L8.94349 5.94826L9.44885 5.95015L9.78716 5.94797L9.85591 5.94687C10.0887 5.94252 10.2998 6.08261 10.3863 6.29873L10.4256 6.39847L10.4783 6.53863L10.5123 6.6344L10.5665 6.79638L10.7704 7.44364L10.8221 7.60194L10.8699 7.74011C10.8777 7.76178 10.8854 7.78285 10.893 7.80343L10.939 7.92206C10.9467 7.94118 10.9545 7.96005 10.9624 7.97879L11.0115 8.09064C11.1233 8.33604 11.2556 8.55655 11.4265 8.77384L11.7639 9.19358L12.2642 9.80352L12.5047 10.0917L12.754 10.3859L12.853 10.5006V3.89344ZM12.4479 11.7334L12.3447 11.62L12.1091 11.3532L11.9383 11.1556L11.7573 10.9428L11.2703 10.3591L10.6445 9.58984L10.5462 9.46631C10.441 9.33254 10.3463 9.19717 10.2604 9.05822L9.08236 9.94173C8.90702 10.0732 8.67273 10.0895 8.48235 9.98761L8.43572 9.95968L7.53078 9.35672L5.30006 9.99413C5.22306 10.0823 5.14454 10.1705 5.06452 10.2586L4.91945 10.4172L4.77869 10.5682L4.5699 10.7866L4.35601 11.0033L4.12813 11.2274L3.87736 11.468L3.59553 11.7334H12.4479ZM9.74507 7.91263L9.78092 8.01783L8.72769 8.80792L7.93699 8.28112L7.88426 8.24998C7.75802 8.18448 7.61073 8.16912 7.47251 8.20861L6.44972 8.50084C6.83789 7.9158 7.15637 7.32289 7.39964 6.71476C7.41247 6.68269 7.42231 6.6495 7.42902 6.61561L7.43426 6.59407C7.44579 6.55239 7.47126 6.48407 7.50891 6.42123L7.52829 6.39069L7.54607 6.36655L7.55917 6.35184L7.65269 6.40699L7.7714 6.48249L7.894 6.56546C8.01165 6.64717 8.13106 6.73559 8.24529 6.82408L8.39073 6.93934C8.48933 7.02041 8.61266 7.06535 8.7403 7.06674L9.47698 7.07013L9.48909 7.10552L9.67884 7.70688L9.74507 7.91263Z"
      fill="#4A4E58"
    />
  </Icon>
);

export const PlayVideoIcon = (props: any) => (
  <Icon width="21px" height="18px" viewBox="0 0 21 18" fill="none" {...props}>
    <rect width="21" height="18" fill="#E5E5E5" />
    <g clipPath="url(#clip0_2400_16695)">
      <rect width="768" height="1278" transform="translate(-203 -359)" fill="black" />
      <rect x="1.375" y="1" width="18.25" height="16" rx="1" stroke="#DADADA" strokeWidth="2" />
      <path fillRule="evenodd" clipRule="evenodd" d="M8.25 5.625V12.375L13.3125 9L8.25 5.625Z" fill="#DADADA" />
      <rect x="3.75" y="3.375" width="2.25" height="2.25" rx="0.4" fill="#DADADA" />
      <rect x="3.75" y="7.875" width="2.25" height="2.25" rx="0.4" fill="#DADADA" />
      <rect x="3.75" y="12.375" width="2.25" height="2.25" rx="0.4" fill="#DADADA" />
      <rect x="15" y="3.375" width="2.25" height="2.25" rx="0.4" fill="#DADADA" />
      <rect x="15" y="7.875" width="2.25" height="2.25" rx="0.4" fill="#DADADA" />
      <rect x="15" y="12.375" width="2.25" height="2.25" rx="0.4" fill="#DADADA" />
    </g>
    <defs>
      <clipPath id="clip0_2400_16695">
        <rect width="768" height="1278" fill="white" transform="translate(-203 -359)" />
      </clipPath>
    </defs>
  </Icon>
);

export const ChevronLeft = (props: any) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.29304 9.29297L12.293 2.29297L13.7073 3.70718L7.41436 10.0001L13.7073 16.293L12.293 17.7072L5.29304 10.7072L4.58594 10.0001L5.29304 9.29297Z"
      fill="currentColor"
    />
  </Icon>
);

export const ChevronRight = (props: any) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.707 10.707L7.70696 17.707L6.29274 16.2928L12.5856 9.99992L6.29274 3.70703L7.70696 2.29282L14.707 9.29282L15.4141 9.99992L14.707 10.707Z"
      fill="currentColor"
    />
  </Icon>
);

export const ShareIcon = (props: any) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3337 4.99972C16.3337 5.73609 15.7367 6.33305 15.0003 6.33305C14.2639 6.33305 13.667 5.73609 13.667 4.99972C13.667 4.26334 14.2639 3.66638 15.0003 3.66638C15.7367 3.66638 16.3337 4.26334 16.3337 4.99972ZM18.3337 4.99972C18.3337 6.84066 16.8413 8.33305 15.0003 8.33305C13.9072 8.33305 12.937 7.80687 12.3291 6.99397L8.11178 8.80139C8.25509 9.17327 8.33366 9.57732 8.33366 9.99971C8.33366 10.422 8.25513 10.8259 8.11189 11.1977L12.3293 13.0052C12.9372 12.1925 13.9073 11.6664 15.0003 11.6664C16.8413 11.6664 18.3337 13.1588 18.3337 14.9997C18.3337 16.8407 16.8413 18.333 15.0003 18.333C13.1594 18.333 11.667 16.8407 11.667 14.9997C11.667 14.9657 11.6675 14.9317 11.6685 14.8979L6.79488 12.8092C6.27684 13.1408 5.66103 13.333 5.00033 13.333C3.15938 13.333 1.66699 11.8407 1.66699 9.99971C1.66699 8.15877 3.15938 6.66638 5.00033 6.66638C5.6609 6.66638 6.27659 6.85853 6.79456 7.18998L11.6685 5.10115C11.6675 5.06746 11.667 5.03365 11.667 4.99972C11.667 3.15877 13.1594 1.66638 15.0003 1.66638C16.8413 1.66638 18.3337 3.15877 18.3337 4.99972ZM15.0003 16.333C15.7367 16.333 16.3337 15.7361 16.3337 14.9997C16.3337 14.2633 15.7367 13.6664 15.0003 13.6664C14.2639 13.6664 13.667 14.2633 13.667 14.9997C13.667 15.7361 14.2639 16.333 15.0003 16.333ZM6.33366 9.99971C6.33366 10.7361 5.7367 11.333 5.00033 11.333C4.26395 11.333 3.66699 10.7361 3.66699 9.99971C3.66699 9.26334 4.26395 8.66638 5.00033 8.66638C5.7367 8.66638 6.33366 9.26334 6.33366 9.99971Z"
      fill="currentColor"
    />
  </Icon>
);

export const ArrowDownIcon = (props: any) => (
  <Icon width="11px" height="9px" viewBox="0 0 11 9" fill="none">
    <path d="M5.5 8.5L0.736861 0.249999L10.2631 0.25L5.5 8.5Z" fill="currentColor" />
  </Icon>
);

export const InfoIcon = (props: any) => (
  <Icon width="25px" height="24px" viewBox="0 0 25 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12C22.5 17.5228 18.0228 22 12.5 22ZM4.5 12C4.5 16.4183 8.08172 20 12.5 20C16.9183 20 20.5 16.4183 20.5 12C20.5 7.58172 16.9183 4 12.5 4C8.08172 4 4.5 7.58172 4.5 12ZM13.5 11L13.5 17H11.5L11.5 11H13.5ZM13.5 7V9H11.5V7H13.5Z"
      fill="currentColor"
    />
  </Icon>
);

export const CheckmarkFilledIcon = (props: any) => (
  <Icon width="24px" height="24px" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.2071 15.7071L17.2071 9.70711L15.7929 8.29289L10.5 13.5858L8.20711 11.2929L6.79289 12.7071L9.79289 15.7071L10.5 16.4142L11.2071 15.7071Z"
      fill="currentColor"
    />
  </Icon>
);

export const DownloadIcon = (props: any) => (
  <Icon width="24px" height="25px" viewBox="0 0 24 25" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 3.5V14.365L17.3598 10.7318L18.6402 12.2682L12.6402 17.2682L12 17.8017L11.3598 17.2682L5.35982 12.2682L6.64018 10.7318L11 14.365V3.5H13ZM4 21.5H20V19.5H4V21.5Z"
      fill="currentColor"
    />
  </Icon>
);

export const ExclamationCircleIcon = (props: any) => (
  <Icon width="40px" height="40px" viewBox="0 0 40 40" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 34C27.732 34 34 27.732 34 20C34 12.268 27.732 6 20 6C12.268 6 6 12.268 6 20C6 27.732 12.268 34 20 34ZM20 37C29.3888 37 37 29.3888 37 20C37 10.6112 29.3888 3 20 3C10.6112 3 3 10.6112 3 20C3 29.3888 10.6112 37 20 37ZM18.5 22V12H21.5V22H18.5ZM21.5 28V25H18.5V28H21.5Z"
      fill="currentColor"
    />
  </Icon>
);
